<template>
  <div v-if="showBasket" id="basket">
     <modal v-if="showModalBasket" frame position="top" size="fluid" @close="showModalBasket = false, $emit('closeBasket')">
        <modal-header>
          <modal-title></modal-title>
          </modal-header>
        <modal-body>
           <!-- basket -->
     <tbl responsive striped>
        <tbl-head color="grey" textWhite>
          <tr v-if="lang === 'RU'">
            <th scope="col">№</th>
            <th scope="col">Наименование</th>
            <th scope="col">Цена, GEL</th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
          <tr v-if="lang === 'EN'">
            <th scope="col">#</th>
            <th scope="col">Description</th>
            <th scope="col">Price, GEL</th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
          <tr v-if="lang === 'GE'">
            <th scope="col">№</th>
            <th scope="col">სახელი</th>
            <th scope="col">ფასი, GEL</th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </tbl-head>
        <tbl-body>
          <tr v-for="(good, index) in orderedList" :key="index" >
            <th>{{index+1}}</th>
            <th v-if="lang === 'RU'">{{good.Артикул+' '}}{{good.PavadinimasRusuKalba}}</th>
            <th v-if="lang === 'EN'">{{good.Артикул+' '}}{{good.PavadinimasAngluKalba}}</th>
            <th v-if="lang === 'GE'">{{good.Артикул+' '}}{{good.Description}}</th>
            <th>{{good.Price}}</th>
            <th> <div class="input-group-prepend">
               <span v-if = "lang === 'RU'" class="input-group-text text-white red hoverable" @click = "good.OrderedQty = 0, good.ConfirmedQty = 0, $emit('addGood', good)" title="Удалить"><i class="fa fa-times text-grey" aria-hidden="true"></i></span>
               <span v-if = "lang === 'EN'" class="input-group-text text-white red hoverable" @click = "good.OrderedQty = 0, good.ConfirmedQty = 0, $emit('addGood', good)" title="Delete"><i class="fa fa-times text-grey" aria-hidden="true"></i></span>
               <span v-if = "lang === 'GE'" class="input-group-text text-white red hoverable" @click = "good.OrderedQty = 0, good.ConfirmedQty = 0, $emit('addGood', good)" title="წაშლა"><i class="fa fa-times text-grey" aria-hidden="true"></i></span>
               <input v-if="lang === 'RU'" type='number' v-bind:value="good.ConfirmedQty" @input="good.ConfirmedQty=calculateInput(good,$event)" @keyup="good.ConfirmedQty=calculateInput(good,$event)" @mousevent="good.ConfirmedQty=calculateInput(good,$event)" class="form-control" v-bind:class=" {'stock': good.Stock, 'miss': ((good.Stock===0) && (good.DeliveryQty===0)), 'transit':((good.Stock===0) && (good.DeliveryQty>0))}" aria-label="Заказано" title="Используйте стрелки вверх-вниз для изменения количества"/>
               <input v-if="lang === 'EN'" type='number' v-bind:value="good.ConfirmedQty" @input="good.ConfirmedQty=calculateInput(good,$event)" @keyup="good.ConfirmedQty=calculateInput(good,$event)" @mousevent="good.ConfirmedQty=calculateInput(good,$event)" class="form-control" v-bind:class=" {'stock': good.Stock, 'miss': ((good.Stock===0) && (good.DeliveryQty===0)), 'transit':((good.Stock===0) && (good.DeliveryQty>0))}" aria-label="Ordered" title="Use the up and down arrows to change the amount."/>
               <input v-if="lang === 'GE'" type='number' v-bind:value="good.ConfirmedQty" @input="good.ConfirmedQty=calculateInput(good,$event)" @keyup="good.ConfirmedQty=calculateInput(good,$event)" @mousevent="good.ConfirmedQty=calculateInput(good,$event)" class="form-control" v-bind:class=" {'stock': good.Stock, 'miss': ((good.Stock===0) && (good.DeliveryQty===0)), 'transit':((good.Stock===0) && (good.DeliveryQty>0))}" aria-label="უბრძანა" title="გამოიყენეთ ქვემოთ და ქვემოთ ისრები, რათა შეიცვალოს თანხა."/>
             </div>
             </th>
            <th><div class="input-group-append">
              <span v-if = "lang === 'RU'" class="input-group-text text-white blue hoverable form-control" @click = "good.OrderedQty=good.ConfirmedQty,$emit('addGood', good)" title="Изменить"><i class="fas fa-cart-arrow-down"></i>
              </span>
              <span v-if = "lang === 'EN'" class="input-group-text text-white blue hoverable form-control" @click = "good.OrderedQty=good.ConfirmedQty,$emit('addGood', good)" title="Change"><i class="fas fa-cart-arrow-down"></i>
              </span>
              <span v-if = "lang === 'GE'" class="input-group-text text-white blue hoverable form-control" @click = "good.OrderedQty=good.ConfirmedQty,$emit('addGood', good)" title="შეიცვალოს"><i class="fas fa-cart-arrow-down"></i>
              </span>
            </div></th>
          </tr>
         </tbl-body>
        <tbl-head color="grey" textWhite>
       <tr>
            <th scope="col"></th>
            <th v-if="lang === 'RU'" scope="col">ИТОГО с НДС:</th>
            <th v-if="lang === 'EN'" scope="col">Total incl. VAT:</th>
            <th v-if="lang === 'GE'" scope="col">დღგ ერთად დღგ:</th>
            <th scope="col" class="th-lg">{{orderedAmount()}}</th>
            <th scope="col" class="th-lg"></th>
            <th scope="col"></th>
          </tr>
       </tbl-head>
      </tbl>
        </modal-body>
        <modal-footer class="d-flex justify-content-center">
          <div v-if="!(просроченныйДолг>100 && долг>0 && (просроченныйДолг>(долг/2)))">
            <btn v-if="lang === 'RU'" color="primary" @click.native="showModalOrder = true, showModalBasket = false">Оформить заказ</btn>
            <btn v-if="lang === 'EN'" color="primary" @click.native="showModalOrder = true, showModalBasket = false">Checkout</btn>
            <btn v-if="lang === 'GE'" color="primary" @click.native="showModalOrder = true, showModalBasket = false">შეკვეთა</btn>
          </div>
         </modal-footer>
      </modal>
  <div class="mt-5">
       <modal  size="lg" v-if="showModalOrder">
        <modal-header @close="showModalOrder = false, $emit('closeBasket')">
          <modal-title>Заказ № {{orders[activeOrder].Number}} от {{orders[activeOrder].Date | moment("DD-MM-YYYY")}}, {{user.Наименование}}</modal-title>
        </modal-header>
        <modal-body>
        <div class="row">
        <div class="col">
       <!-- Group of default radios - option 1 -->
          <div class="custom-control custom-radio">
            <input @change="$emit('Самовывоз'), address = warehouse, delivery = 'Самовывоз'" type="radio" class="custom-control-input" id="Самовывоз" name="groupOfDelivery" checked>
            <label class="custom-control-label" for="Самовывоз">Самовывоз</label>
          </div>

          <!-- Group of default radios - option 2 -->
          <div class="custom-control custom-radio">
            <input @change="$emit('Доставка'), address = clientaddress, delivery = 'Доставка'" type="radio" class="custom-control-input" id="Доставка" name="groupOfDelivery">
            <label class="custom-control-label" for="Доставка">Доставка</label>
          </div>
        </div>
         <div class="col">
       <!-- Group of default radios - option 3 -->
          <div class="custom-control custom-radio">
            <input @change="$emit('Предоплата'), payment = 'Предоплата' " type="radio" class="custom-control-input" id="Предоплата" name="groupOfPayment" checked>
            <label class="custom-control-label" for="Предоплата">Предоплата</label>
          </div>

          <!-- Group of default radios - option 4 -->
          <div class="custom-control custom-radio">
            <input @change="$emit('Отсрочка'), payment = 'Отсрочка'" type="radio" class="custom-control-input" id="Отсрочка" name="groupOfPayment">
            <label class="custom-control-label" for="Отсрочка">Отсрочка {{ user.ЭтапыГрафикаОплаты[0].Сдвиг }} дней</label>
          </div>

          </div>
    </div>
        <!-- Default form contact -->
<form>
     <!-- Default input name -->
    <label for="defaultFormContactNameEx" class="grey-text">Адрес</label>
    <input v-model="address" type="text" id="defaultFormContactNameEx" class="form-control">

    <br>

    <!-- Default input email -->
    <label for="defaultFormContactEmailEx" class="grey-text">Ваш email</label>
    <input v-model="email" type="email" id="defaultFormContactEmailEx" class="form-control">

    <br>

    <!-- Default input subject -->
    <label for="defaultFormContactSubjectEx" class="grey-text">Телефон</label>
    <input v-model="phone" type="text" id="defaultFormContactSubjectEx" class="form-control">

    <br>

    <!-- Default textarea message -->
    <label for="defaultFormContactMessageEx" class="grey-text">Комментарий к заказу</label>
     <div class="form-group">
       <textarea v-if="payment = 'Отсрочка' "  v-model="newcomment" class="form-control" id="exampleFormControlTextarea1" rows="1"></textarea>
       <textarea v-if="payment = 'Предоплата' && orderedAmount() > 200 && orderedAmount() < 500" v-model="newcomment" class="form-control" id="exampleFormControlTextarea1" rows="1"></textarea>\
     </div>
</form>
<!-- Default form contact -->
          <div class="input-group d-flex justify-content-center">
           <div class="input-group-prepend">
             <span class="input-group-text green-text">
                 Сумма заказа {{orderedAmount() }} BYN
             </span>
           </div>
                 <div class="input-group-append">
                    <span v-if="orderedAmount() > 200" class="input-group-text green-text">
                        Бесплатная доставка
                    </span>
                    <span v-if="orderedAmount() < 200" class="input-group-text">
                         До бесплатной доставки {{Math.round((200-orderedAmount()) * 100) / 100 }} BYN
                   </span>
                </div>
          </div>
       </modal-body>
        <modal-footer>
          <btn color="secondary" @click.native="$emit('closeBasket'), showModalOrder = false">Назад</btn>
          <btn color="primary" @click.native="postOrder(), showModalOrder = false, $emit('closeBasket')">Разместить заказ</btn>
        </modal-footer>
      </modal>
  </div>
 </div>
 </template>

<script>
import { Row, Column, Btn, Card, Container, CardBody, CardHeader, CardText, Fa, BarChart, PieChart, LineChart, RadarChart, DoughnutChart, ListGroup, ListGroupItem, Badge, Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, mdbTooltip, mdbPopover, mdbBtn, NumericInput, Tbl, TblHead, TblBody } from 'mdbvue'
import ApiService from '@/services/ApiService'
export default {
  name: 'basket',
  components: {
    Row,
    Container,
    Column,
    Btn,
    Card,
    CardBody,
    CardHeader,
    CardText,
    Fa,
    BarChart,
    PieChart,
    LineChart,
    RadarChart,
    DoughnutChart,
    ListGroup,
    ListGroupItem,
    Badge,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    mdbTooltip,
    mdbPopover,
    mdbBtn,
    NumericInput,
    Tbl,
    TblHead,
    TblBody
  },
  props: ['showBasket', 'lang', 'goods', 'orders', 'activeOrder', 'user', 'comment', 'goodsInfotronic', 'просроченныйДолг', 'долг'],
  event: 'close',
  watch: {
    showBasket () {
      this.showModalBasket = this.ShowBasket
    }
  },
  data () {
    return {
      errors: [],
      postBody: '',
      search: '',
      found: false,
      newcomment: '',
      showModalOrder: false,
      showModalBasket: true,
      warehouse: 'г.Минск, ул Платонова, 36, помещение 1-Торг',
      address: 'г.Минск, ул Платонова, 36, помещение 1-Торг',
      payment: 'Предоплата',
      delivery: 'Самовывоз',
      clientaddress: '',
      email: '',
      phone: ''
    }
  },
  mounted () {
    /*
    this.user.КонтактнаяИнформация.forEach((item) => {
      if (item.Тип === 'Адрес') this.clientaddress = item.Представление
      if (item.Тип === 'Телефон') this.phone = item.Представление
      if (item.Тип === 'АдресЭлектроннойПочты') this.email = item.Представление
    })
  */
    // console.log('mounted basket')
    this.$emit('basket')
    // if (this.comment === '') {
    this.newcomment = this.comment
    // }
  },
  updated () {
  },
  computed: {
    orderedList () {
      if (this.goods.length > 0) {
        return this.goods.filter(good => {
          if (good.ConfirmedQty > 0) {
            return true
          } else {
            return false
          }
        }
        )
      }
    }
  },
  methods:
    {
      calculateInput (good, event) {
        // console.log(event.target.value)
        if (event.target.value <= 0 || good.OrderedQty <= 0 || good.ConfirmedQty <= 0) {
          good.OrderedQty = 1
          good.ConfirmedQty = 1
          good.changed = true
          event.target.value = 1
          return 1
        } else return event.target.value
      },
      calculateid (refkey) {
        return 'i' + refkey
      },
      isDelete (good, index, event) {
        if (event.target.value < 1) {
          this.$dialog
            .confirm('Для изменения количества используйте стрелки вверх-вниз. Удалить товар из корзины?')
            .then(function (dialog, event) {
              // console.log('Clicked on proceed ')
              good.OrderedQty = 0
              this.$emit('addGood', good)
              // console.log(good.ConfirmedQty)
            })
            .catch(function () {
              // console.log('Clicked on cancel')
              // event.target.value = 1
              // console.log(good.ConfirmedQty)
              good.OrderedQty = good.ConfirmedQty
            })
        } else {
          // console.log('Else')
          this.orderedList[index].OrderedQty = event.target.value
        }
      },
      async postOrder () {
        // console.log('postOrder ' + event)
        // console.log(this.orders[this.activeOrder])
        var msUTC = Date.parse(this.orders[this.activeOrder]['Date']) // зона UTC
        var date = new Date(msUTC)
        var orderDate = '' + date.getDate() + '/' + parseInt(date.getMonth() + 1) + '/' + date.getFullYear() + ' Время ' + date.getHours() + ':' + date.getMinutes()
        var message = this.$localStorage.get('Description') + '=>' + this.orders[this.activeOrder]['Number'] + ' от ' + orderDate + ' на сумму:' + this.orderedAmount() + ' Доставка:' + this.delivery + ' по адресу:' + this.address + ' Оплата:' + this.payment + ' Контактный телефон:' + this.phone
        // console.log(message)
        var orderuid = this.orders[this.activeOrder]['Ref_Key']
        var dataVersion = this.orders[this.activeOrder]['DataVersion']
        var maxline = this.orders[this.activeOrder]['Товары'].length
        // console.log(this.orders[this.activeOrder])
        // console.log('maxline ' + maxline)
        var comment = this.newcomment.toString()
        // console.log(comment)
        await ApiService.postOrder(orderuid, comment, message, dataVersion, maxline)
        // let data = response.data
        // console.log(data)
        this.$dialog.alert('Заказ отправлен в обработку!').then(function (dialog) {
          // console.log('Sent')
        })
        // this.getOrderList()
      },
      orderedAmount () {
        if (this.orderedList === undefined) {
          return 0
        }
        var sum = 0
        this.orderedList.forEach(function (item, i, arr) {
          sum += Math.floor(item.Price * item.OrderedQty * 100) / 100
        })
        return Math.floor(sum * 100) / 100
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-control:focus {
    border:0px
    }
.order-btn {
    margin-top: 0.375rem;
    margin-left: 0rem;
    }
.search {
    border: 1px solid #1e282d;
    }
.stock {
    border: 1px solid #007e33;
    }
.miss {
    border: 1px solid #ffbb33;
    }
.transit {
    border: 1px solid #ff8800;
    }
.w-120 {
    width: 120px!important;
}
.w-50 {
    width: 60px!important;
}
.inp {
    font-size: 1.5rem;
}
.md-form {
    position: relative;
    margin-top: 0rem;
    margin-bottom: 0rem;
}
.cascading-admin-card {
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 5px;
}
.m-0 {
    margin: 0.4rem!important;
}
.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
}
.cascading-admin-card .admin-up .fa {
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2), 0 2px 20px 0 rgba(0, 0, 0, 0.19);
}
.cascading-admin-card .admin-up .fa {
  padding: 1.7rem;
  font-size: 2rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  border-radius: 3px;
}
.cascading-admin-card .admin-up .data {
  float: right;
  margin-top: 2rem;
  text-align: right;
}
.admin-up .data p {
  color: #999999;
  font-size: 12px;
}
.classic-admin-card .card-body {
  color: #fff;
  margin-bottom: 0;
  padding: 0.9rem;
}
  .card-text {
  font-size: 16px;
  opacity: 1.0;
  margin-bottom: 0;
  margin-left: 1rem;
  font-weight: 300;
}
.classic-admin-card .card-body h4 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Basket.vue